module.exports = __webpack_public_path__ + "static/img/cloud-2.4d26fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/cloud-2.png
// module id = zfeG
// module chunks = 0